// extracted by mini-css-extract-plugin
export default {"home-aside":"index_home-aside__-EKsO"};